import { useState, useEffect, useRef } from 'react'
import View from '@modul-connect/shared/components/atoms/view'
import { Icon } from '../../atoms/icon'
import { P } from '../../atoms/text'
import theme from '../../../theme'

const InfoLabel = ({ label, required, showInfoIcon, showInfoText, infoText, bold }) => {
  const [isInfoOpen, setIsInfoOpen] = useState(false)
  const ref = useRef(null)
  const S = styles

  useEffect(() => {
    if (!isInfoOpen) return

    const handleClickOutside = event => {
      if (ref.current && !ref.current.contains(event.target)) {
        setIsInfoOpen(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [isInfoOpen])

  return (
    <View extend={S.label_row}>
      <View extend={[S.label_text, bold && { fontWeight: 700 }]}>
        <span>{label}</span>
        {required && <span style={S.required_mark}>*</span>}
      </View>

      {showInfoIcon && (
        <div ref={ref} style={{ display: 'flex' }}>
          <View
            onClick={() => setIsInfoOpen(prev => !prev)}
            extend={S.info_icon_wrapper}
          >
            <Icon icon='info' />

            {showInfoText && isInfoOpen && (
              <View extend={S.info_text_box}>
                <Icon icon='info' />
                <P noPadding>{infoText}</P>
              </View>
            )}
          </View>
        </div>
      )}
    </View>
  )
}

const styles = {
  label_row: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8
  },

  label_text: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    fontFamily: 'Inter',
    fontStyle: 'normal',
    fontSize: 12,
    lineHeight: '15px',
    letterSpacing: '0.02em',
    textTransform: 'uppercase',
  },

  required_mark: {
    color: theme.colors.error,
    marginLeft: 2
  },

  info_icon_wrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    cursor: 'pointer'
  },

  info_text_box: {
    display: 'flex',
    alignItems: 'flex-start',
    position: 'absolute',
    minWidth: '190px',
    maxWidth: '360px',
    borderRadius: 8,
    top: -7,
    left: -7,
    fontFamily: 'Inter',
    fontStyle: 'normal',
    fontSize: 12,
    lineHeight: '16px',
    color: '#141414',
    backgroundColor: theme.colors.white,
    zIndex: 1000,
    padding: '8px',
    gap: 8

  }
}

export default InfoLabel